<template>
    <MultiSelect
        v-model="selectedItems"
        :loading="isLoading"
        :options="itemList"
        optionLabel="label"
        optionGroupLabel="label"
        optionGroupChildren="items"
        display="chip"
        class="w-full"
        :maxSelectedLabels="3"
        filter
        :showToggleAll="false"
        scrollHeight="20rem"
        @update:modelValue="onUpdated"
    ></MultiSelect>
</template>

<script setup>
import { ref, defineEmits, defineProps, inject, onMounted, watch } from "vue";
import { MultiSelect } from "primevue";

const optionsService = inject("optionsService");
const emit = defineEmits(["update:selection"]);

const props = defineProps({
    optionType: {
        type: String,
    },
    selection: {
        type: Array,
        required: true,
    },
});

const selectedItems = ref(null);
const itemList = ref([]);
const isLoading = ref(true);

onMounted(async () => {
    await getItems();
});

const stop = watch(
    () => props.selection,
    () => {
        selectedItems.value = props.selection;
        stop();
    },
);

const getItems = async () => {
    const response = await optionsService.getOptionsByType(props.optionType, ["active"], false);

    itemList.value = response;
    isLoading.value = false;
};

const onUpdated = async (event) => {
    emit("update:selection", selectedItems.value);
};
</script>

<style scoped></style>
